import React from 'react';
import HeroImage from '../../assets/imgs/hh.jpg';

function HeroSection() {
  return (
    <section 
      className="hero-section d-flex align-items-center justify-content-center text-center"
      style={{
        backgroundImage: `url(${HeroImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: "80vh", // Define a altura da seção
        color: "white", // Mantém o texto visível sobre a imagem
        display: "flex",
        flexDirection: "column",
        textShadow: "2px 2px 10px rgba(0, 0, 0, 0.7)" // Dá um efeito de destaque no texto
      }}
    >
      <div className="container">
        <h1 className="display-4 fw-bold">Bem-vindo à Visão Positiva</h1>
        <p className="lead">Garantimos transparência e segurança na análise do seu veículo.</p>
        <a href="#servicos" className="btn btn-primary btn-lg">Conheça nossos serviços</a>
      </div>
    </section>
  );
}

export default HeroSection;
